"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var defaultProps = {
    footerRegion: 'US',
    enabled: true,
    submitUrl: '/api/subscribe',
    title: 'Get the latest news and important updates from FF',
    subtitle: 'Sign up for the latest of the FF 91 Futurist and other news about Faraday Future',
    inputPlaceholder: 'Email*',
    inputErrorMessage: 'Please provide a valid email',
    serverErrorMessage: 'Something went wrong. Please try again later.',
    successMessage: 'Your subscription has been confirmed. You’ll receive the latest news and updates from Faraday Future.',
    button: 'Subscribe →',
};
exports.default = defaultProps;
